module.exports = __webpack_public_path__ + "img/Calendar.55f0315c.svg";